import { Link } from "react-router-dom";
import { LegalLayout } from "@/components/SiteFooter";
import { Seo } from "@/components/Seo";

export default function WhyFree() {
  return (
    <LegalLayout title="Why Free?">
      <Seo title="Why Free?" description="PillarWealth.io is free because it is supported by advertising on public pages, not by selling your data or charging subscriptions." path="/why-free" />
      <p>Good retirement planning shouldn't sit behind a paywall, especially for people who already have one of the lowest-cost retirement plans in the country. So the tracker is free to use, with no trial period and no premium tier.</p>
      <h2>How we pay the bills</h2>
      <p>The site is supported by ads from Google AdSense, shown on public pages such as the Content Hub and the daily TSP market recaps. That revenue covers hosting, market data and the daily price pipeline.</p>
      <h2>What we don't do</h2>
      <ul>
        <li>We don't sell your personal or financial information.</li>
        <li>We don't share your balances, holdings or paycheck data with advertisers.</li>
        <li>We don't push you toward any fund, product or advisor, and we don't earn commissions on your choices.</li>
      </ul>
      <h2>Your part</h2>
      <p>If the site helps you, the best support is to keep reading the articles and share it with a coworker who's still guessing at their TSP. Details on data and ads are in our <Link to="/privacy">Privacy Policy</Link> and <Link to="/cookies">Cookie Policy</Link>.</p>
      <p>Contact: <a href="mailto:support@atkinsmedia.io" data-testid="whyfree-contact-email">support@atkinsmedia.io</a></p>
    </LegalLayout>
  );
}
